module.exports = __webpack_public_path__ + "static/media/ws-home-delivery.518b39d7.svg";